import { z } from 'zod';
import { AiProvider } from './ai.js';
export const AiHarnessProfile = z.enum(['native', 'guided', 'json']);
/** Exact deployment IDs: never infer capability or price from a model's name. */
export const AiHarnessModelProfile = z.strictObject({
    provider: AiProvider,
    modelId: z.string().trim().min(1).max(200),
    profile: AiHarnessProfile,
    maxOutputTokens: z.number().int().min(256).max(64_000).optional(),
});
export const AiHarnessModelProfiles = z
    .array(AiHarnessModelProfile)
    .max(100)
    .superRefine((rows, ctx) => {
    const seen = new Set();
    rows.forEach((row, index) => {
        const key = JSON.stringify([row.provider, row.modelId]);
        if (seen.has(key)) {
            ctx.addIssue({
                code: 'custom',
                path: [index, 'modelId'],
                message: 'Duplicate provider/model profile',
            });
        }
        seen.add(key);
    });
});
/** Stored as text so the existing settings editor can edit and validate it. */
export const AiHarnessModelProfilesJson = z
    .string()
    .max(30_000)
    .superRefine((raw, ctx) => {
    try {
        const parsed = AiHarnessModelProfiles.safeParse(JSON.parse(raw));
        if (parsed.success)
            return;
        for (const issue of parsed.error.issues)
            ctx.addIssue({ ...issue, code: 'custom' });
    }
    catch {
        ctx.addIssue({ code: 'custom', message: 'Expected a JSON array of model profiles' });
    }
});
//# sourceMappingURL=ai-harness-profile.js.map